module.exports = __webpack_public_path__ + "static/media/see_no_darkbleu.7198472f.svg";